export const isSingaporeRestrictionActive = false
